// extracted by mini-css-extract-plugin
export var backButton = "PitchHomePage-module__backButton___sOG12";
export var linkPaneContainer = "PitchHomePage-module__linkPaneContainer___DehNA";
export var spinnerWrapper = "PitchHomePage-module__spinnerWrapper___+s2jg";
export var xboxGreen = "#107C10";